module.exports = __webpack_public_path__ + "img/1530849724.fa2d4723.jpg";